import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Box,
  Grid,
  Stack,
  Button,
  Dialog,
  Select,
  Tooltip,
  Divider,
  MenuItem,
  TextField,
  Typography,
  FormControl,
  DialogContent,
  DialogActions,
  FormHelperText,
} from "@mui/material";
//Import from project
import "../../../Style/dialogstyle.scss";
import moment from "moment";
import EmptyImage from "../../../Assets/empty-image.png";
import CropImageFile from "../../CropImage/CropImageFile";
import LoadingProgess from "../../../Utils/LoadingProgress";

import { useMutation } from "@apollo/client";
import { AuthContext } from "../../../Context/AuthContext";
import { DialogTitleComp } from "../../../Utils/Component";
import { SelectDatePicker } from "../../Include/SelectDatePicker";
import { useDeleteImageServer } from "../../CropImage/DeleteImageServer";
import { CREATE_MEMBER, UPDATE_MEMBER } from "../../../Schema/Member";
import {
  SelectCommune,
  SelectDistrict,
  SelectProvince,
  SelectVillage,
} from "../../Include/DynamicSelect";
import {
  formatPhoneNumber,
  toEnglishNumber,
  toLatinUppercase,
} from "../../../Function/DynamicFn";

export default function MemberForm({
  open,
  onChange = () => {},
  editData,
  setRefetch,
  handleClose,
  dialogTitle,
  hideBackdrop,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const mutationDelete = useDeleteImageServer();
  // =================================== Upload Image ====================================
  const [profileHook, setProfileHook] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [openCrop, setOpenCrop] = useState(false);

  const [statusProgress, setStatusProgress] = useState(false);
  const [progress, setProgress] = useState(10);

  const handleUploadImage = (e) => {
    const imageFile = e.target.files[0];
    if (imageFile) {
      setImageFile(imageFile);
      setPhotoURL(URL.createObjectURL(imageFile));
      setOpenCrop(true);
    }
  };

  const handleCloseAction = () => {
    handleClose();
    if (profileHook) {
      // delete iamge from server ====================================================
      let splitSrc = profileHook?.split(":")[4];
      mutationDelete.mutate({
        storage: "sr_province_council",
        folder: "council_images",
        file: splitSrc.split("/")[0],
      });
    }
    setProfileHook("");
    setImageFile("");
  };

  const [createMember] = useMutation(CREATE_MEMBER, {
    onCompleted: ({ createMember }) => {
      setLoading(false);
      if (createMember?.isSuccess === true) {
        if (onChange) {
          onChange({
            id: createMember?.data?._id,
            title:
              createMember?.data?.firstNameKh +
              " " +
              createMember?.data?.lastNameKh,
          });
        }
        setAlert(true, "success", createMember?.message);
        handleClose();
        resetForm();
        setRefetch();
        setProfileHook("");
        setImageFile("");
      } else {
        setAlert(true, "error", createMember?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateMember] = useMutation(UPDATE_MEMBER, {
    onCompleted: ({ updateMember }) => {
      setLoading(false);
      if (updateMember?.isSuccess === true) {
        setAlert(true, "success", updateMember?.message);
        handleClose();
        resetForm();
        setRefetch();
        setProfileHook("");
        setImageFile("");
      } else {
        setAlert(true, "error", updateMember?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    role: Yup.string().required(t("required")),
    email: Yup.string().email("Invalid email format"), // ✅ checks format like user@example.com
    gender: Yup.string().required(t("required")),
    remark: Yup.string(),
    profile: Yup.string(),
    telegram: Yup.string(),
    latinName: Yup.string(),
    lastNameKh: Yup.string().required(t("required")),
    firstNameKh: Yup.string().required(t("required")),
    phoneNumber: Yup.string(),
    dateOfBirth: Yup.string().required(t("required")),
    nationalIdCardNumber: Yup.string(),

    current_address_village_id: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string(),
    }),
    current_address_commune_sangkat_id: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string(),
    }),
    current_address_capical_provinces_id: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string(),
    }),
    current_address_district_municipalities_id: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string(),
    }),

    place_Of_birth_village_id: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string(),
    }),
    place_Of_birth_commune_sangkat_id: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string(),
    }),
    place_Of_birth_capical_provinces_id: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string(),
    }),
    place_Of_birth_district_municipalities_id: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      role: "Member",
      email: "",
      remark: "",
      gender: "Male",
      profile: "",
      telegram: "0",
      latinName: "",
      lastNameKh: "",
      dateOfBirth: "",
      firstNameKh: "",
      phoneNumber: "0",
      nationalIdCardNumber: "",

      current_address_village_id: { id: "", title: "" },
      current_address_commune_sangkat_id: { id: "", title: "" },
      current_address_capical_provinces_id: { id: "", title: "" },
      current_address_district_municipalities_id: { id: "", title: "" },

      place_Of_birth_village_id: { id: "", title: "" },
      place_Of_birth_commune_sangkat_id: { id: "", title: "" },
      place_Of_birth_capical_provinces_id: { id: "", title: "" },
      place_Of_birth_district_municipalities_id: { id: "", title: "" },
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);

      const inputData = {
        role: values?.role,
        remark: values?.remark,
        email: values?.email,
        gender: values?.gender,
        telegram: values?.telegram,
        latinName: values?.latinName,
        lastNameKh: values?.lastNameKh,
        phoneNumber: values?.phoneNumber,
        firstNameKh: values?.firstNameKh,
        nationalIdCardNumber: `${values?.nationalIdCardNumber}`,
        placeOfBirth: {
          village_id: values?.place_Of_birth_village_id?.id || null,
          commune_sangkat_id:
            values?.place_Of_birth_commune_sangkat_id?.id || null,
          capical_provinces_id:
            values?.place_Of_birth_capical_provinces_id?.id || null,
          district_municipalities_id:
            values?.place_Of_birth_district_municipalities_id?.id || null,
        },
        currentAddress: {
          village_id: values?.current_address_village_id?.id || null,
          commune_sangkat_id:
            values?.current_address_commune_sangkat_id?.id || null,
          capical_provinces_id:
            values?.current_address_capical_provinces_id?.id || null,
          district_municipalities_id:
            values?.current_address_district_municipalities_id?.id || null,
        },
      };

   
      if (dialogTitle === "Create") {
        createMember({
          variables: {
            input: {
              ...inputData,
              profile: profileHook,
              dateOfBirth: moment(values?.dateOfBirth).format("YYYY-MM-DD"),
            },
          },
        });
      } else {
        updateMember({
          variables: {
            id: editData?._id,
            input: {
              ...inputData,
              profile: profileHook ? profileHook : editData?.profile,
              dateOfBirth: moment(values?.dateOfBirth).format("YYYY-MM-DD"),
            },
          },
        });
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData && dialogTitle === "Update") {
      setFieldValue("role", editData?.role || "");
      setFieldValue("remark", editData?.remark || "");
      setFieldValue("email", editData?.email || "");
      setFieldValue("gender", editData?.gender || "");
      setFieldValue("telegram", editData?.telegram || "");
      setFieldValue("latinName", editData?.latinName || "");
      setFieldValue("lastNameKh", editData?.lastNameKh || "");
      setFieldValue("firstNameKh", editData?.firstNameKh || "");
      setFieldValue("dateOfBirth", editData?.dateOfBirth || "");
      setFieldValue("phoneNumber", editData?.phoneNumber || "");
      setFieldValue(
        "nationalIdCardNumber",
        editData?.nationalIdCardNumber || ""
      );

      setFieldValue("place_Of_birth_village_id", {
        id: editData?.placeOfBirth?.village_id?._id || "",
        title: editData?.placeOfBirth?.village_id?.village_name_kh || "",
      });

      setFieldValue("place_Of_birth_commune_sangkat_id", {
        id: editData?.placeOfBirth?.commune_sangkat_id?._id || "",
        title:
          editData?.placeOfBirth?.commune_sangkat_id?.commune_sangkat_name_kh ||
          "",
      });

      setFieldValue("place_Of_birth_capical_provinces_id", {
        id: editData?.placeOfBirth?.capical_provinces_id?._id || "",
        title:
          editData?.placeOfBirth?.capical_provinces_id
            ?.capital_province_name_kh || "",
      });

      setFieldValue("place_Of_birth_district_municipalities_id", {
        id: editData?.placeOfBirth?.district_municipalities_id?._id || "",
        title:
          editData?.placeOfBirth?.district_municipalities_id
            ?.district_municipality_name_kh || "",
      });

      setFieldValue("current_address_village_id", {
        id: editData?.currentAddress?.village_id?._id || "",
        title: editData?.currentAddress?.village_id?.village_name_kh || "",
      });

      setFieldValue("current_address_commune_sangkat_id", {
        id: editData?.currentAddress?.commune_sangkat_id?._id || "",
        title:
          editData?.currentAddress?.commune_sangkat_id
            ?.commune_sangkat_name_kh || "",
      });

      setFieldValue("current_address_capical_provinces_id", {
        id: editData?.currentAddress?.capical_provinces_id?._id || "",
        title:
          editData?.currentAddress?.capical_provinces_id
            ?.capital_province_name_kh || "",
      });

      setFieldValue("current_address_district_municipalities_id", {
        id: editData?.currentAddress?.district_municipalities_id?._id || "",
        title:
          editData?.currentAddress?.district_municipalities_id
            ?.district_municipality_name_kh || "",
      });
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      className="dialog-container"
      maxWidth="sm"
      fullWidth
      hideBackdrop={hideBackdrop}
    >
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_member")
            : t("modal_title_update_member")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleCloseAction}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                {!openCrop ? (
                  <Box>
                    <Stack direction="row" justifyContent="center">
                      <Tooltip title="click to upload">
                        <Button component="label">
                          <TextField
                            className="text-field"
                            type="file"
                            id="image"
                            sx={{ display: "none" }}
                            onChange={handleUploadImage}
                          />
                          <img
                            className="avater-image"
                            src={
                              imageFile
                                ? URL.createObjectURL(imageFile)
                                : editData?.profile
                                ? editData?.profile
                                : EmptyImage
                            }
                          />
                        </Button>
                      </Tooltip>
                    </Stack>
                  </Box>
                ) : (
                  <CropImageFile
                    setProgress={setProgress}
                    setStatusProgress={setStatusProgress}
                    openCrop={openCrop}
                    setOpenCrop={setOpenCrop}
                    photoURL={photoURL}
                    setPhotoURL={setPhotoURL}
                    setImageFile={setImageFile}
                    setProfileHook={setProfileHook}
                  />
                )}

                {statusProgress && progress < 100 ? (
                  <LoadingProgess
                    progress={progress}
                    setProgress={setProgress}
                  />
                ) : (
                  <Typography
                    className={t("class-name-field-title")}
                    sx={{ textAlign: "center", marginTop: "6px" }}
                  >
                    {t("thead_profile")}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_last_name")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_last_name")}
                  {...getFieldProps("lastNameKh")}
                  error={Boolean(touched.lastNameKh && errors.lastNameKh)}
                  helperText={touched.lastNameKh && errors.lastNameKh}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_first_name")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_first_name")}
                  {...getFieldProps("firstNameKh")}
                  error={Boolean(touched.firstNameKh && errors.firstNameKh)}
                  helperText={touched.firstNameKh && errors.firstNameKh}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_latin_name")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_latin_name")}
                  // {...getFieldProps("latinName")}
                  value={values.latinName}
                  onChange={(e) => {
                    const input = e.target.value;
                    const uppercased = toLatinUppercase(input);
                    setFieldValue("latinName", uppercased);
                  }}
                  error={Boolean(touched.latinName && errors.latinName)}
                  helperText={touched.latinName && errors.latinName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_gender")}
                </Typography>
                <FormControl fullWidth className="search-field" size="small">
                  <Select
                    value={values?.gender}
                    onChange={(e) => setFieldValue("gender", e?.target.value)}
                  >
                    <MenuItem value={"Male"}>{t("thead_male")}</MenuItem>
                    <MenuItem value={"Female"}>{t("thead_female")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_date_of_birth")}
                </Typography>
                <SelectDatePicker
                  value={values?.dateOfBirth}
                  onChange={(val) => setFieldValue("dateOfBirth", val)}
                />
                {!!errors?.dateOfBirth && touched?.dateOfBirth && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors?.dateOfBirth}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_national_id_card_number")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={"#############"}
                  value={values.nationalIdCardNumber}
                  onChange={(e) => {
                    const input = e.target.value;
                    const number = toEnglishNumber(input);
                    setFieldValue("nationalIdCardNumber", number);
                  }}
                  // {...getFieldProps("nationalIdCardNumber")}
                  error={Boolean(
                    touched.nationalIdCardNumber && errors.nationalIdCardNumber
                  )}
                  helperText={
                    touched.nationalIdCardNumber && errors.nationalIdCardNumber
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_email")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_email")}
                  {...getFieldProps("email")}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_phone_number")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_phone_number")}
                  value={values?.phoneNumber}
                  onChange={(e) => {
                    const formatted = formatPhoneNumber(e.target.value);
                    setFieldValue("phoneNumber", formatted);
                  }}
                  error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                  helperText={touched.phoneNumber && errors.phoneNumber}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_telegram")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_telegram")}
                  value={values?.telegram}
                  onChange={(e) => {
                    const formatted = formatPhoneNumber(e.target.value);
                    setFieldValue("telegram", formatted);
                  }}
                  error={Boolean(touched.telegram && errors.telegram)}
                  helperText={touched.telegram && errors.telegram}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  className={t("class-name-field-title")}
                  sx={{ fontWeight: "bold" }}
                >
                  {t("thead_place_of_birth")}
                </Typography>
                <Divider />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_capital_province")}
                </Typography>

                <SelectProvince
                  dialogTitle={dialogTitle}
                  value={values?.place_Of_birth_capical_provinces_id}
                  onChange={(val) => {
                    setFieldValue("place_Of_birth_capical_provinces_id", val);
                    setFieldValue("place_Of_birth_district_municipalities_id", {
                      id: "",
                      title: "",
                    });
                    setFieldValue("place_Of_birth_commune_sangkat_id", {
                      id: "",
                      title: "",
                    });
                    setFieldValue("place_Of_birth_village_id", {
                      id: "",
                      title: "",
                    });
                  }}
                  helperText={
                    touched.place_Of_birth_capical_provinces_id?.id &&
                    errors.place_Of_birth_capical_provinces_id?.id
                  }
                  error={Boolean(
                    touched.place_Of_birth_capical_provinces_id?.id &&
                      errors.place_Of_birth_capical_provinces_id?.id
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_municipality_district")}
                </Typography>

                <SelectDistrict
                  dialogTitle={dialogTitle}
                  capicalProvincesId={
                    values?.place_Of_birth_capical_provinces_id?.id || ""
                  }
                  value={values?.place_Of_birth_district_municipalities_id}
                  onChange={(val) => {
                    setFieldValue(
                      "place_Of_birth_district_municipalities_id",
                      val
                    );
                    setFieldValue("place_Of_birth_commune_sangkat_id", {
                      id: "",
                      title: "",
                    });
                    setFieldValue("place_Of_birth_village_id", {
                      id: "",
                      title: "",
                    });
                  }}
                  helperText={
                    touched.place_Of_birth_district_municipalities_id?.id &&
                    errors.place_Of_birth_district_municipalities_id?.id
                  }
                  error={Boolean(
                    touched.place_Of_birth_district_municipalities_id?.id &&
                      errors.place_Of_birth_district_municipalities_id?.id
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_commune_sangkat")}
                </Typography>
                <SelectCommune
                  districtMunicipalitiesId={
                    values?.place_Of_birth_district_municipalities_id?.id || ""
                  }
                  value={values?.place_Of_birth_commune_sangkat_id}
                  onChange={(val) => {
                    setFieldValue("place_Of_birth_commune_sangkat_id", val);
                    setFieldValue("place_Of_birth_village_id", {
                      id: "",
                      title: "",
                    });
                  }}
                  helperText={
                    touched.place_Of_birth_commune_sangkat_id?.id &&
                    errors.place_Of_birth_commune_sangkat_id?.id
                  }
                  error={Boolean(
                    touched.place_Of_birth_commune_sangkat_id?.id &&
                      errors.place_Of_birth_commune_sangkat_id?.id
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_village")}
                </Typography>
                <SelectVillage
                  communeSangkatId={
                    values?.place_Of_birth_commune_sangkat_id?.id || ""
                  }
                  value={values?.place_Of_birth_village_id}
                  onChange={(val) => {
                    setFieldValue("place_Of_birth_village_id", val);
                  }}
                  helperText={
                    touched.place_Of_birth_village_id?.id &&
                    errors.place_Of_birth_village_id?.id
                  }
                  error={Boolean(
                    touched.place_Of_birth_village_id?.id &&
                      errors.place_Of_birth_village_id?.id
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  className={t("class-name-field-title")}
                  sx={{ fontWeight: "bold" }}
                >
                  {t("thead_current_address")}
                </Typography>
                <Divider />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_capital_province")}
                </Typography>

                <SelectProvince
                  dialogTitle={dialogTitle}
                  value={values?.current_address_capical_provinces_id}
                  onChange={(val) => {
                    setFieldValue("current_address_capical_provinces_id", val);
                    setFieldValue(
                      "current_address_district_municipalities_id",
                      { id: "", title: "" }
                    );
                    setFieldValue("current_address_commune_sangkat_id", {
                      id: "",
                      title: "",
                    });
                    setFieldValue("current_address_village_id", {
                      id: "",
                      title: "",
                    });
                  }}
                  helperText={
                    touched.current_address_capical_provinces_id?.id &&
                    errors.current_address_capical_provinces_id?.id
                  }
                  error={Boolean(
                    touched.current_address_capical_provinces_id?.id &&
                      errors.current_address_capical_provinces_id?.id
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_municipality_district")}
                </Typography>
                <SelectDistrict
                  dialogTitle={dialogTitle}
                  capicalProvincesId={
                    values?.current_address_capical_provinces_id?.id || ""
                  }
                  value={values?.current_address_district_municipalities_id}
                  onChange={(val) => {
                    setFieldValue(
                      "current_address_district_municipalities_id",
                      val
                    );
                    setFieldValue("current_address_commune_sangkat_id", {
                      id: "",
                      title: "",
                    });
                    setFieldValue("current_address_village_id", {
                      id: "",
                      title: "",
                    });
                  }}
                  helperText={
                    touched.current_address_district_municipalities_id?.id &&
                    errors.current_address_district_municipalities_id?.id
                  }
                  error={Boolean(
                    touched.current_address_district_municipalities_id?.id &&
                      errors.current_address_district_municipalities_id?.id
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_commune_sangkat")}
                </Typography>
                <SelectCommune
                  districtMunicipalitiesId={
                    values?.current_address_district_municipalities_id?.id || ""
                  }
                  value={values?.current_address_commune_sangkat_id}
                  onChange={(val) => {
                    setFieldValue("current_address_commune_sangkat_id", val);
                    setFieldValue("current_address_village_id", {
                      id: "",
                      title: "",
                    });
                  }}
                  helperText={
                    touched.current_address_commune_sangkat_id?.id &&
                    errors.current_address_commune_sangkat_id?.id
                  }
                  error={Boolean(
                    touched.current_address_commune_sangkat_id?.id &&
                      errors.current_address_commune_sangkat_id?.id
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_village")}
                </Typography>
                <SelectVillage
                  communeSangkatId={
                    values?.current_address_commune_sangkat_id?.id || ""
                  }
                  value={values?.current_address_village_id}
                  onChange={(val) =>
                    setFieldValue("current_address_village_id", val)
                  }
                  helperText={
                    touched.current_address_village_id?.id &&
                    errors.current_address_village_id?.id
                  }
                  error={Boolean(
                    touched.current_address_village_id?.id &&
                      errors.current_address_village_id?.id
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_remark")}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  className="text-field"
                  placeholder={t("thead_remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
      <DialogActions sx={{ padding: 3 }}>
        {loading ? (
          <Button className={t("class-btn-create")} fullWidth>
            {t("loading")}
          </Button>
        ) : (
          <Button
            className={t("class-btn-create")}
            fullWidth
            onClick={handleSubmit}
          >
            {dialogTitle === "Update" ? t("update") : t("create")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
